// extracted by mini-css-extract-plugin
export default {"block__title__style":"TitleMain_block__title__style__8Vzk7","title__style":"TitleMain_title__style__8o+s8","ellipse__style":"TitleMain_ellipse__style__Yc5ql"};